import { render, staticRenderFns } from "./JobsDashboardWidget.vue?vue&type=template&id=5a1ebb96&scoped=true"
import script from "./JobsDashboardWidget.vue?vue&type=script&lang=js"
export * from "./JobsDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./JobsDashboardWidget.vue?vue&type=style&index=0&id=5a1ebb96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ebb96",
  null
  
)

export default component.exports